//@flow
import React from 'react'
import { ModalContent, Root, ModalHeader } from './styledComponents'
import closeIcon from '../../images/close.svg'
import SVG from 'react-svg-inline'
const Modal =  (props: Props) => {
    const { open, children, onClose  } = props;
    if (!open)
        return null;
    return <Root>
        <ModalContent>
            <ModalHeader>
                <SVG svg={closeIcon} height="14px" onClick={onClose} />
            </ModalHeader>
            { children }
        </ModalContent>
    </Root>
}

type Props = {
    open: boolean,
    children: Array<any>,
    onClose: Function
}
export default Modal



